// Centralized social links — update these to real URLs when accounts are live
export const SOCIAL_LINKS = {
  instagram: "https://instagram.com/apuseniactive",
  facebook: "https://facebook.com/apuseniactive",
  tiktok: "https://tiktok.com/@apuseniactive",
  whatsapp: "https://wa.me/40752354222",
};

// Custom TikTok icon (not in lucide-react)
export const TikTokIcon = ({ className = "w-5 h-5", strokeWidth = 1.5 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

// Custom WhatsApp icon (cleaner outline than the default brand version)
export const WhatsAppIcon = ({ className = "w-5 h-5", strokeWidth = 1.5 }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" />
    <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1" />
  </svg>
);
